import { render, staticRenderFns } from "./faNavBar.vue?vue&type=template&id=0a2b5508&scoped=true"
import script from "./faNavBar.vue?vue&type=script&lang=js"
export * from "./faNavBar.vue?vue&type=script&lang=js"
import style0 from "./faNavBar.vue?vue&type=style&index=0&id=0a2b5508&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2b5508",
  null
  
)

export default component.exports